/**
 * @param startDate
 * @param finishDate
 * @returns {number}
 */
function calculateDaysCount(startDate, finishDate) {
  const dateStart = new Date(startDate);
  const dateFinish = new Date(finishDate);

  dateStart.setHours(0);
  dateStart.setMinutes(0);
  dateStart.setSeconds(0);

  dateFinish.setDate(dateFinish.getDate() + 1);
  dateFinish.setHours(0);
  dateFinish.setMinutes(0);
  dateFinish.setSeconds(0);

  return (dateFinish.getTime() - dateStart.getTime()) / (1000 * 60 * 60 * 24);
}

export default calculateDaysCount;
